import CF from './CF.json';
import TP from './TP.json';
import S from './S.json';
import PAQ_C from './PAQ_C.json';
import PAQ_A from './PAQ_A.json';
import BAF from './BAF.json';
import PL from './PL.json';
import KIDMED from './KIDMED.json';
import SCOFF from './SCOFF.json';
import BS from './BS.json';
import DK from './DK.json';
import KS from './KS.json';
import FAS from './FAS.json';
import DK_Padres from './DK_Padres.json';
import KS_Padres from './KS_Padres.json';
import UMARS from './UMARS.json';

const QuestionnaireDefinitions = {
  CF,
  TP,
  S,
  PAQ_C,
  PAQ_A,
  BAF,
  PL,
  KIDMED,
  SCOFF,
  BS,
  DK,
  KS,
  FAS,
  DK_Padres,
  KS_Padres,
  UMARS
};

export default QuestionnaireDefinitions;